import React, { useContext } from 'react'

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { useTranslation } from 'react-i18next';
import { i18nContext } from '../i18n/i18nContext';

/**
 * すべての応募画面に表示するヘッダー
 */
export function Header() {

    const [t] = useTranslation();

    const {lng, setLng} = useContext(i18nContext);

    function HandleLanguage(
        event: React.MouseEvent<HTMLElement>,
        changeLng: string | null,
    ) {
        if (changeLng !== null) {
            setLng(changeLng);
        }
    };

    return(
        <>
            <AppBar position="static" color='primary'>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box>
                            <Typography
                                variant="h6"
                                noWrap
                            >
                                {t("Header.Logo")}
                            </Typography>
                        </Box>
                        <Box sx={{flexGrow: 1}}></Box>
                        <Box>
                            Language
                            <ToggleButtonGroup
                                value={lng}
                                exclusive
                                onChange={HandleLanguage}
                                aria-label="text alignment"
                                sx={{
                                    backgroundColor: "#ffffff",
                                    ml: 2
                                }}
                            >
                                <ToggleButton value="ja" aria-label="ja aligned" color="info">
                                    JP
                                </ToggleButton>
                                <ToggleButton value="en" aria-label="en aligned" color="info">
                                    EN
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                        
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    );
}